import { render, staticRenderFns } from "./TextCourseTable.vue?vue&type=template&id=28fa44d3&scoped=true&"
import script from "./TextCourseTable.vue?vue&type=script&lang=js&"
export * from "./TextCourseTable.vue?vue&type=script&lang=js&"
import style0 from "./TextCourseTable.vue?vue&type=style&index=0&id=28fa44d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa44d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VDataTable,VPagination,VRow})
